export enum SItemTypeEnum{
    JSON = "JSON",
    XML = "XML"
}
